<div class="navbar">
  <div class="wrap">
    <div class="container-fluid d-flex">
      <div class="navbar-logo" *ngIf="!isBayerCaddy">
        <a href="/home" id="header-buyerCaddyLogo">
          <img src="/assets/images/logo.png" alt="salescaddi.ai logo" width="135px" />
        </a>
      </div>
      <div class="navbar-logo" *ngIf="isBayerCaddy" role="button" (click)="goTo('/buyer-home')">
        <!-- <a href="/buyer-home" id="header-buyerCaddyLogo">
          <img src="/assets/images/logoFinal.svg" alt="salescaddi.ai logo" width="135px" />
        </a> -->
      </div>
      <div class="navbar-menu" *ngIf="!isBayerCaddy">

        <a routerLink="/home" class="navbar-menu-item" routerLinkActive="active" id="header-link-toHome">
          Home
        </a>
        <a routerLink="/contact" class="navbar-menu-item" routerLinkActive="active" id="header-link-toSearch">
          Search
        </a>
        <a routerLink="/meetings" class="navbar-menu-item" routerLinkActive="active" id="header-link-toMeetings">
          Meetings
        </a>
        <a routerLink="/insights" class="navbar-menu-item" routerLinkActive="active" id="header-link-toLeads">
          Leads
        </a>
      </div>
      <div class="navbar-menu d-flex" *ngIf="isBayerCaddy">
        <a routerLink="/buyer-home" class="navbar-menu-item" routerLinkActive="active" id="header-link-toBuyerHome">
          Home
        </a>
        <a [routerLink]="getSearchRoute()" class="navbar-menu-item" routerLinkActive="active" id="header-link-toSearch">
          Search
        </a>
        <app-auto-open-menu>
          <div trigger>
            <a routerLink="/transformation-journeys" *ngIf="isBayerCaddy" class="navbar-menu-item"
              routerLinkActive="active" id="header-link-toTechStacks">
              <span>Tech Stacks</span>
              <mat-icon class="navbar-menu-item__arrow">keyboard_arrow_down</mat-icon>
            </a>
          </div>
          <div content id="header-techStacks-menu">
            <button type="button" role="menuitem" class="header-dropdown-item" routerLink="/tech-stack-visualizer" routerLinkActive="active" id="techStacksMenu-link-toVisualizer">
              <span class="header-dropdown-item__content">
                <span class="header-dropdown-item__icon"><mat-icon>visibility</mat-icon></span>
                <span class="header-dropdown-item__label">Visualizer</span>
              </span>
            </button>
            <button type="button" role="menuitem" class="header-dropdown-item" routerLink="/tech-editor" routerLinkActive="active" id="techStacksMenu-link-toCircuit">
              <span class="header-dropdown-item__content">
                <span class="header-dropdown-item__icon"><mat-icon>account_tree</mat-icon></span>
                <span class="header-dropdown-item__label">Circuit Board</span>
              </span>
            </button>
            <button type="button" role="menuitem" class="header-dropdown-item" routerLink="/buyer-insights" routerLinkActive="active" id="techStacksMenu-link-toInsights">
              <span class="header-dropdown-item__content">
                <span class="header-dropdown-item__icon"><mat-icon>insights</mat-icon></span>
                <span class="header-dropdown-item__label">Analyze Insights</span>
              </span>
            </button>
            <button type="button" role="menuitem" class="header-dropdown-item" routerLink="/setup-cohorts" routerLinkActive="active" id="techStacksMenu-link-toCohorts">
              <span class="header-dropdown-item__content">
                <span class="header-dropdown-item__icon"><mat-icon>groups</mat-icon></span>
                <span class="header-dropdown-item__label">Cohorts</span>
              </span>
            </button>
          </div>
        </app-auto-open-menu>
        <a *ngIf="this.userProfileDataService.userProfileData?.company" [routerLink]="null" (click)="gotoCompanyPage()"
          class="navbar-menu-item" role="button" [ngClass]="{ active: isCurrentPage('/company-v2') }" id="header-link-toCompany">
          My Companies
        </a>
        <a *ngIf="isPeopleViewer" routerLink="/my-contacts" role="button" class="navbar-menu-item" routerLinkActive="active" id="header-link-toMyProfiles">
          My Profiles
        </a>
        <app-auto-open-menu>
          <div trigger>
            <a [routerLink]="null" class="navbar-menu-item" [ngClass]="{ active: isInsightsMenuActive() }" id="header-link-toInsights">
              <span>Insights</span>
              <mat-icon class="navbar-menu-item__arrow">keyboard_arrow_down</mat-icon>
            </a>
          </div>
          <div content id="header-insights-menu">
            <button type="button" role="menuitem" class="header-dropdown-item" routerLink="/buyer-insights" routerLinkActive="active" id="insightsMenu-link-toTechStacks">
              <span class="header-dropdown-item__content">
                <span class="header-dropdown-item__icon"><mat-icon>insights</mat-icon></span>
                <span class="header-dropdown-item__label">Tech Stacks</span>
              </span>
            </button>
            <button type="button" role="menuitem" class="header-dropdown-item" routerLink="/skills-intelligence" routerLinkActive="active" id="insightsMenu-link-toSkills">
              <span class="header-dropdown-item__content">
                <span class="header-dropdown-item__icon"><mat-icon>psychology</mat-icon></span>
                <span class="header-dropdown-item__label">Skills</span>
              </span>
            </button>
          </div>
        </app-auto-open-menu>
      </div>
      <div class="d-flex align-items-center">


        <button mat-button class="company-switch-trigger" [matMenuTriggerFor]="companyMenu"
          #companyMenuTrigger="matMenuTrigger"
          (mouseenter)="openHeaderMenuOnHover(companyMenuTrigger)"
          (mouseleave)="scheduleHeaderMenuClose(companyMenuTrigger)"
          (menuOpened)="onHeaderMenuOpened(companyMenuTrigger)"
          (menuClosed)="onHeaderMenuClosed(companyMenuTrigger)"
          *ngIf="this.companies?.length >= 2">
          <span class="company-switch-trigger__content">
            <span class="company-switch-trigger__logo" aria-hidden="true">
              <clearbit-logo class="logo-tile" *ngIf="selectedCompany?.domain" [domain]="selectedCompany?.domain" [height]="24" [width]="24"></clearbit-logo>
            </span>
            <span class="company-switch-trigger__text text-truncate white-color"
              [matTooltip]="selectedCompany?.name"
              matTooltipPosition="below">
              {{selectedCompany?.name}}
            </span>
            <mat-icon class="company-switch-trigger__arrow white-color">keyboard_arrow_down</mat-icon>
          </span>
        </button>
        <mat-menu #companyMenu="matMenu" class="company-menu-panel" [hasBackdrop]="false">
          <div *ngFor="let company of this.companies" class="company-menu-row"
            [class.is-selected]="company.id == this.selectedCompany?.id"
            (mouseenter)="openHeaderMenuOnHover(companyMenuTrigger)"
            (mouseleave)="scheduleHeaderMenuClose(companyMenuTrigger)">
            <button type="button" mat-menu-item class="company-menu-item" (click)="changeCompany(company)"
              [disabled]="company.id == this.selectedCompany?.id">
              <span class="company-menu-item__content">
                <span class="company-menu-item__logo" aria-hidden="true">
                  <clearbit-logo class="logo-tile" *ngIf="company?.domain" [domain]="company?.domain" [height]="26" [width]="26"></clearbit-logo>
                  <mat-icon *ngIf="!company?.domain">business</mat-icon>
                </span>
                <span class="company-menu-item__text text-truncate" [matTooltip]="company.name"
                  matTooltipPosition="right">
                  <b *ngIf="company.id == this.profileCompanyId" class="text-truncate d-block">{{company.name}}</b>
                  <span *ngIf="company.id != this.profileCompanyId" class="text-truncate d-block">{{company.name}}</span>
                </span>
                <span *ngIf="company.id == this.selectedCompany?.id" class="company-menu-item__status">Current</span>
              </span>
            </button>
            <button type="button"
              *ngIf="company.id != this.profileCompanyId && company.id != this.selectedCompany?.id"
              class="company-menu-item__action"
              [attr.aria-label]="'Remove ' + company.name + ' from managed companies'"
              (click)="this.deleteCompanyFromManagmentList(company.id, $event)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </mat-menu>




        <div class="navbar-btn d-flex align-items-center">
          <div class="alert alert-warning mt-2 me-2 p-2" role="alert" *ngIf="this.isUserAs">
            <div class="d-flex justify-content-end  align-items-center ms-2 white-color">
              <span>You are logged in as <b>{{this.userNameAs}}</b></span>
              <button class="btn btn-sm btn-primary ms-2" (click)="onLogoutAs()" id="header-button-logout">LogOut</button>
            </div>
          </div>

          <div class="navbar-userpic">
            <button class="btn" mat-button [matMenuTriggerFor]="menu" #userMenuTrigger="matMenuTrigger"
              (mouseenter)="openHeaderMenuOnHover(userMenuTrigger)"
              (mouseleave)="scheduleHeaderMenuClose(userMenuTrigger)"
              (menuOpened)="onHeaderMenuOpened(userMenuTrigger)"
              (menuClosed)="onHeaderMenuClosed(userMenuTrigger)"
              disableRipple id="header-button-menuTrigger">
              <div class="d-flex align-items-center user-menu-text">
                <div class="navbar-avatar">
                  <img src="{{ this.authService.getUserClaims()?.picture}} " alt="">
                </div>
                <span>{{ userName }}</span>
                <mat-icon>keyboard_arrow_down</mat-icon>
              </div>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <mat-menu #menu="matMenu" class="user-menu-panel" [hasBackdrop]="false">

                <a class="dropdown-item user-menu-item" routerLink="/profile" mat-menu-item routerLinkActive="active" href
                  (mouseenter)="openHeaderMenuOnHover(userMenuTrigger)"
                  (mouseleave)="scheduleHeaderMenuClose(userMenuTrigger)"
                  id="header-button-toProfile">
                  <span class="user-menu-item__icon"><i class="fal fa-address-book"></i></span>
                  <span class="user-menu-item__label">My Profile</span>
                </a>
                <a *ngIf="isBayerCaddy" class="dropdown-item user-menu-item" routerLink="/setup-cohorts" mat-menu-item
                  (mouseenter)="openHeaderMenuOnHover(userMenuTrigger)"
                  (mouseleave)="scheduleHeaderMenuClose(userMenuTrigger)"
                  routerLinkActive="active" href id="header-button-linkToCohorts">
                  <span class="user-menu-item__icon"><i class="fal fa-pencil"></i></span>
                  <span class="user-menu-item__label">My Cohorts</span>
                </a>
                <a class="dropdown-item user-menu-item user-menu-item--logout" (click)="onLogout()" stopPropagation mat-menu-item href
                  (mouseenter)="openHeaderMenuOnHover(userMenuTrigger)"
                  (mouseleave)="scheduleHeaderMenuClose(userMenuTrigger)"
                  id="header-button-logout">
                  <span class="user-menu-item__icon"><i class="fal fa-sign-out-alt"></i></span>
                  <span class="user-menu-item__label">Log out</span>
                </a>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
      <!-- <button *ngIf="!isBayerCaddy" mat-raised-button color="warn"  class="navbar-btn-item ms-4 " style="font-size: 18px; font-weight: 500;"
              (click)="switchToBuyerCaddy()" matTooltip="Switch to BuyerCaddy">
        BuyerCaddy
      </button>

      <button *ngIf="isBayerCaddy" mat-raised-button color="accent"  class="navbar-btn-item ms-4 " style="font-size: 18px; font-weight: 500;"
              (click)="switchToSalesCaddy()" matTooltip="Switch to SalesCaddy">
        SalesCaddy
      </button> -->
    </div>

  </div>
</div>

<button *ngIf="showAiChat" class="ai-chat-button" (click)="startAi()">
<img src="../../../../assets/images/ai/rachel-ai10.png" width="40px" height="40px" style=" border-radius: 50%;" alt="Rachel" class="profile-pic me-3" />
  Ask Rachel
</button>

